import React from 'react';
import { Linkedin, Github, Mail, BookOpen } from 'lucide-react';
import { profile } from '../data/portfolio';

const Footer = () => {
  const links = [
    { icon: Linkedin, href: profile.socials.linkedin, label: 'LinkedIn' },
    { icon: Github, href: profile.socials.github, label: 'GitHub' },
    { icon: BookOpen, href: profile.socials.goodreads, label: 'Goodreads' },
    { icon: Mail, href: profile.socials.email, label: 'Email' }
  ];
  return (
    <footer className="mt-24 border-t border-border/60">
      <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              target="_blank"
              rel="noreferrer"
              aria-label={l.label}
              className="w-10 h-10 rounded-lg border border-border flex items-center justify-center text-ink-soft hover:text-foreground hover:bg-brand/10 hover:border-brand/60 hover:shadow-md hover:-translate-y-0.5 transition-all"
            >
              <l.icon size={16} />
            </a>
          ))}
        </div>
        <div className="text-[12px] mono uppercase tracking-widest text-ink-mute">
          © {new Date().getFullYear()} Veeresh Wali
        </div>
      </div>
    </footer>
  );
};

export default Footer;
